import { Message, User } from '@progress/kendo-react-conversational-ui';
import ElsieAvatar from '../../../../assets/avatars/elsieai-avatar.svg';

export const aiUser: User = {
  id: 'elsieAi',
  name: 'Elsie AI',
};
export const aiUserV2: User = {
  id: 'elsieAi',
  name: 'Elsie AI',
  avatarUrl: ElsieAvatar,
  avatarAltText: 'Elsie AI avatar',
};

export const summarizeMessage: Omit<Message, 'author'> = {
  text: 'Generate a summary and key points based on current data filters.',
};

export const coachMeMessage: Omit<Message, 'author'> = {
  text: 'Coach me',
};

export function getShowTypingMessage(version: 1 | 2): Message {
  return {
    author: version === 2 ? aiUserV2 : aiUser,
    typing: true,
  };
}
